

















import Vue from 'vue';
import Component from 'vue-class-component';
import SectionLayout from '@/components/SectionLayout.vue';
import BackgroundVideo from '@/components/BackgroundVideo.vue';
import NavBar from '@/components/NavBar';
import ForgotPassword from '@/components/Auth/Password/ForgotPassword.vue';
import SuccessCard from '@/components/Auth/SuccessCard.vue';
import { authModule } from '@/utils/store-acessor';

@Component({
  components: {
    SuccessCard,
    SectionLayout,
    BackgroundVideo,
    NavBar,
    ForgotPassword
  }
})
export default class ForgotPasswordPage extends Vue {
  success = false;

  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;

  changeSuccess(value: boolean) {
    this.success = value;
  }
}
